export const colors = {
  white: 'var(--color-white)',
  darkBlue: 'var(--color-dark-blue)',
  red: 'var(--color-red)',
  blue: 'var(--color-blue)',
  pink: 'var(--color-pink)',
  purple: 'var(--color-purple)',
  lightBlue: 'var(--color-light-blue)',
  orange: 'var(--color-orange)',
  yellow: 'var(--color-yellow)',
  green: 'var(--color-green)',
  black: 'var(--color-black)',

  border: 'var(--border-color)',

  primary: 'var(--color-primary)',
  secondary: 'var(--color-secondary)',
}
